import { lazy } from "react";

export const MembershipAsync = lazy(()=> import('./Membership'))
